import moment from 'moment'

export function money (value) {
  return parseFloat(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}
export function moneyWithoutRS (value) {
  return parseFloat(value).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
}
export function moneyFormatted (value) {
  if (!value) {
    return '-'
  }
  return 'R$ ' + parseFloat(value).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
}

export function formatMoneyOrDash (value) {
  if (value === null || value === undefined || isNaN(value)) {
    return '-'
  }
  return money(value)
}

export function paddingLeftTwoCases (value) {
  if (typeof value === 'number') {
    // Convert number to string and pad with leading zeros to ensure at least two characters
    return value.toString().padStart(2, '0')
  } else if (typeof value === 'string') {
    // Pad the string with leading spaces to ensure at least two characters
    return value.padStart(2, ' ')
  } else {
    // For other types, return the value unchanged or handle accordingly
    return value
  }
}

export function cep (value) {
  return value.length === 8 ? `${value.substring(0, 5)}-${value.substring(5, 8)}` : value
}

export function cpf (value) {
  return value && value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4')
}

export function cnpj (value) {
  if (!value) return value

  const str = String(value).replace(/[^A-Za-z0-9]/g, '')

  if (/[a-zA-Z]/.test(str)) {
    return str.replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/g, '$1.$2.$3/$4-$5')
  }

  return str.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5')
}

export function celular (value) {
  return value && value.toString().replace(/(\d{2})(\d{5})(\d{4})/g, '($1) $2-$3')
}

export function toDateBR (value) {
  return convertToDateBR(value)
}

export function toDateTimeBR (value) {
  return moment(value, 'YYYY-MM-DD HH:mm:ss.uuu').format('DD/MM/YYYY H:mm:ss')
}

export function toDateTimeBRSemHoraVazia (value) {
  const dateTime = moment(value, 'YYYY-MM-DD HH:mm:ss.uuu')

  if (dateTime.hours() === 0 && dateTime.minutes() === 0 && dateTime.seconds() === 0) {
    return dateTime.format('DD/MM/YYYY')
  }

  return dateTime.format('DD/MM/YYYY H:mm:ss')
}

export function toDateBrWithHour (value) {
  return moment(toDateBR(value), 'DD/MM/YYYY H:m:s').format('DD/MM/YYYY H:mm:ss')
}

export function primeiraMaiuscula (value) {
  return value
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

export function percentage (value) {
  if (value !== null) {
    const numericValue = value || 0
    return numericValue === 0
      ? `${numericValue}%`
      : numericValue
        .toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }) + '%'
  } else {
    return '-'
  }
}

function convertToDateBR (value, withTime = false) {
  let pieces = []
  if (!value) {
    return ''
  }
  if (!value.includes('-')) {
    return value
  }
  if (value.includes('T')) {
    pieces = value.split('T')
  } else {
    pieces = value.split(' ')
  }
  const date_us = pieces[0]
  const date_pieces = date_us.split('-')

  let date_br = `${date_pieces[2]}/${date_pieces[1]}/${date_pieces[0]}`

  if (withTime) {
    date_br += pieces[1]
  }

  return date_br
}

export function formatarCpfCnpj (value) {
  if (!value) return '-'
  const cleanValue = value.replace(/\D/g, '')
  if (cleanValue.length === 11) {
    return cpf(cleanValue)
  } else if (cleanValue.length === 14) {
    return cnpj(cleanValue)
  }
  return value
}

export function formatRG (rgValue) {
  if (!rgValue) {
    return ''
  }
  let newValue = rgValue.replace(/[^0-9a-zA-Z]/g, '').replace(/\s+/g, '')
  newValue = newValue.slice(0, 20)

  let numbersPart = newValue.replace(/[A-Za-z]/g, '')
  let lettersPart = newValue.match(/[A-Za-z]+$/) || ''

  if (lettersPart && numbersPart.length === 0) {
    lettersPart = ''
  }

  lettersPart = lettersPart.toString().slice(-2)
  newValue = numbersPart + lettersPart

  return newValue
}
